import * as Menubar from '@radix-ui/react-menubar';
import { Button } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { ClickCatcher } from 'components/common/layout/click-catcher';
import { CommonMenuBarItems } from 'components/common/menu-bar/items';
import { IMenuBarMenu } from 'interfaces/i-menu-bars';
import { RADIX } from 'lib_ts/enums/radix-ui';
import './index.scss';

interface IProps {
  menus: IMenuBarMenu[];
}

export const CommonMenuBar = (props: IProps) => {
  return (
    <ErrorBoundary identifier="CommonMenuBar">
      <ClickCatcher>
        <Menubar.Root>
          {props.menus
            .filter((m) => !m.invisible)
            .map((m) => (
              <Menubar.Menu key={m.id}>
                <Menubar.Trigger
                  disabled={m.disabled}
                  onClick={m.onClick}
                  asChild
                >
                  <Button
                    color={m.color ?? RADIX.COLOR.SECONDARY}
                    variant={m.variant ?? RADIX.BUTTON.VARIANT.SECONDARY}
                    className="MenuBarTrigger"
                  >
                    {m.trigger}
                  </Button>
                </Menubar.Trigger>
                <Menubar.Portal>
                  {!m.disabled && m.items && (
                    <CommonMenuBarItems items={m.items} />
                  )}
                </Menubar.Portal>
              </Menubar.Menu>
            ))}
        </Menubar.Root>
      </ClickCatcher>
    </ErrorBoundary>
  );
};
